export const routeNames = {
	List: "List",
	Create: "Create"
};
